export default "__VITE_ASSET__DEKPaqc$__"